"use client"

import { useQuery } from "@tanstack/react-query"

import { useAuth } from "@/hooks/use-auth"
import type { BackgroundJobRow } from "@/lib/db/background-jobs-dal"

export const knowledgeBaseSocialImportJobsQueryKey = [
  "knowledge-base",
  "social-import-jobs",
] as const

export function useKnowledgeBaseSocialImportJobsQuery(options: {
  enabled?: boolean
  pollIntervalMs?: number
} = {}) {
  const { fetchWithAuth } = useAuth()
  const enabled = options.enabled ?? true
  const pollIntervalMs = options.pollIntervalMs ?? 3000

  return useQuery<{ jobs: BackgroundJobRow[] }>({
    queryKey: knowledgeBaseSocialImportJobsQueryKey,
    enabled,
    refetchInterval: query => {
      if (!enabled) return false
      const jobs = query.state.data?.jobs ?? []
      return jobs.some(job => job.status === "pending" || job.status === "running")
        ? pollIntervalMs
        : false
    },
    queryFn: async () => {
      const response = await fetchWithAuth(
        "/api/ai/knowledge-base/social-import/jobs/recent",
      )
      const data = await response.json()
      if (!response.ok) {
        throw new Error(data.error || "Failed to load social import status")
      }
      return { jobs: Array.isArray(data.jobs) ? data.jobs : [] }
    },
  })
}
